export { default } from '@relo/sports-components/es/SlabNavContainer';
export * from '@relo/sports-components/es/SlabNavContainer';
